import { useEffect, useState } from 'react'
import { useRegisterSW } from 'virtual:pwa-register/react'
import toast from 'react-hot-toast'

export default function PWAUpdateNotification() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW()

  const [showReload, setShowReload] = useState(false)

  useEffect(() => {
    if (needRefresh) {
      setShowReload(true)
      toast((t) => (
        <div className="flex flex-col gap-2">
          <p className="font-semibold">Nueva versión disponible</p>
          <p className="text-sm">¿Deseas actualizar la aplicación?</p>
          <div className="flex gap-2 mt-2">
            <button
              onClick={() => {
                updateServiceWorker(true)
                toast.dismiss(t.id)
              }}
              className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Actualizar
            </button>
            <button
              onClick={() => {
                setNeedRefresh(false)
                setShowReload(false)
                toast.dismiss(t.id)
              }}
              className="px-3 py-1 bg-gray-600 text-white rounded hover:bg-gray-700"
            >
              Más tarde
            </button>
          </div>
        </div>
      ), {
        duration: Infinity,
        position: 'bottom-center',
      })
    }
  }, [needRefresh, updateServiceWorker, setNeedRefresh])

  return null
}


